var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 3.33333H13.9997M7.33301 6H10.6663",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.33333H2.66667C2.29848 3.33333 2 3.63181 2 4V5.33333C2 5.70152 2.29848 6 2.66667 6H4C4.36819 6 4.66667 5.70152 4.66667 5.33333V4C4.66667 3.63181 4.36819 3.33333 4 3.33333Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 10H13.9997M7.33301 12.6667H10.6663",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10H2.66667C2.29848 10 2 10.2985 2 10.6667V12C2 12.3682 2.29848 12.6667 2.66667 12.6667H4C4.36819 12.6667 4.66667 12.3682 4.66667 12V10.6667C4.66667 10.2985 4.36819 10 4 10Z",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.35a9383e65e0ad032399efa9ca1c1bd6.svg";
export { ForwardRef as ReactComponent };